import request from '@/utils/request';
import { ApiPrefix } from '@/constants/constants';

export default {
	changeQyId(id: string) {
		return request({
			url: ApiPrefix.QyApiDefault + '/xiaoxiang/index/qiye/switch?id=' + id,
			method: 'POST',
		});
	},
};
